export const PANEL_AREA_DEFAULT_DIMENSION = {
  WIDTH: 4,
  HEIGHT: 3,
};
